import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-view-ride',
  templateUrl: './view-ride.component.html',
  styleUrls: ['./view-ride.component.scss'],
})
export class ViewRideComponent implements OnInit {
  data: any;
  isSubmitting = true;
  today: number = Date.now();
  queryData: any = {
    fromAddress: null,
    toAddress: null,
    startTime: Date.now(),
  };
  queryFlag = false;
  constructor(
    public api: ApiService,
    private titleService: Title,
    private router: Router,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      'Search a Trip, Find a ride, Request a Lift, get new friends on Matesride by Autoscoop'
    );
    this.meta.updateTag({
      name: 'description',
      content:
        'Trip to Canberra, trip to Sydney, trip to Melbourne, trip to Brisbane, trip to Adelaid, trip to Gold Coast, trip to Perth, trip to Great Ocean Drive',
    });
    this.meta.updateTag({
      name: 'keywords',
      content:
        'carpooling to Canberra, Carpooling to Melbourne, Carpooling to Sydney, Rideshare ,View ride, View Trip, Rider, Co-rider, Ride Passion, Long Ride, Enjoy ride',
    });
    this.fetchData();
    // this.route.queryParams.subscribe(params => {
    //   this.queryFlag = params['queryFlag'];
    //   if (this.queryFlag) {
    //     this.queryData.fromAddress = params['from'] || '';
    //     this.queryData.toAddress = params['to'] || '';
    //     this.queryData.startTime = new Date(params['date']) || '';
    //   }
    //   this.fetchData();
    // });
  }

  fetchData() {
    this.api.viewAllRides().subscribe(
      r => {
        this.data = r;
        this.isSubmitting = false;
      },
      error => {
        this.data = null;
      }
    );
  }
  // raiseRequest(rideId) {
  //   if (!this.loginService.isAuthenticated()) {
  //     this.generalService.openSignInDialog(
  //       'Before submitting the form, you need to login.'
  //     );
  //   } else {
  //     this.isSubmitting = true;
  //     const data = {
  //       requestStatus: 'Submitted',
  //       userId: this.loginService.getUserId(),
  //       idp: rideId,
  //       lastName: this.loginService.getName()
  //     };
  //     this.api.postRequestForRideId(data).subscribe(
  //       r => {
  //         // console.log(r);
  //         this.generalService.trackEvent('Request', 'Raise a request', 'trip');
  //         this.isSubmitting = false;
  //         const dialogRef = this.dialog.open(ThankYouDialogComponent, {
  //           width: '400px',
  //           data: {
  //             body: 'Track your Request status in profile Page',
  //             requestId: r.rideRequestId
  //           }
  //         });

  //         dialogRef.afterClosed().subscribe(result => {
  //           this.router.navigate(['/']);
  //         });
  //       },
  //       error => {
  //         console.log(error);
  //         this.isSubmitting = false;
  //       }
  //     );
  //   }
  // }
}
